import request from '@/utils/acRequest'

// 获取学校列表
export const getSchoolLists = (data) => {
    return request({
        url: '/school/lists',
        params: data
    })
}

// 获取学校选项列表
export const getSchoolOptionLists = () => {
    return request({
        url: '/school/option/lists'
    })
}

/**
 * 详情
 */
export const getDetail = (id) => {
    return request({
        url: `/school/${id}`
    })
}

// 获取学校地图设置列表
export const getSchoolMapSettingList = (data) => {
    return request({
        url: '/school/map/setting/lists',
        params: data
    })
}

// 获取学校地图设置详情
export const getSchoolMapSettingDetail = (id) => {
    return request({
        url: `/school/map/setting/${id}`
    })
}

// 获取学校地图设置详情
export const putchoolMapSetting = (data) => {
    return request({
        url: '/school/map/setting',
        method: 'PUT',
        data
    })
}

// 获取我的学校地图设置详情
export const getMyMapSettingDetail = () => {
    return request({
        url: '/school/map/setting'
    })
}

// 获取我的学校地图设置详情
export const setMyMapSettingDetail = (data) => {
    return request({
        url: '/school/map/setting',
        method: 'POST',
        data
    })
}

// 添加
export const addSchool = (data) => {
    return request({
        url: '/school/manage',
        method: 'POST',
        data
    })
}

// 修改
export const putSchool = (data) => {
    return request({
        url: '/school/manage',
        method: 'PUT',
        data
    })
}

// 删除
export const delSchool = (data) => {
    return request({
        url: `/school/${data}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/school/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/school/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/school/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}

// 重置密码
export const resetPass = (data) => {
    return request({
        url: '/system/user/reset_password',
        method: 'POST',
        data
    })
}

// 获取学校列表
export const getMySchool = () => {
    return request({
        url: '/school/my/school'
    })
}

// 提交学校列表
export const updateMySchool = (data) => {
    return request({
        url: '/school/my/school',
        method: 'POST',
        data
    })
}

// 进入单位
export const enterSchool = (data) => {
    return request({
        url: '/public/login/switch',
        method: 'POST',
        data
    })
}
// 指定学校具备功能
export const setSchoolFunctions = (data) => {
    return request({
        url: '/school/functions',
        method: 'POST',
        data
    })
}
